import { render, staticRenderFns } from "./AsideSettingsSection.vue?vue&type=template&id=3105b895&scoped=true&"
import script from "./AsideSettingsSection.vue?vue&type=script&lang=js&"
export * from "./AsideSettingsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3105b895",
  null
  
)

export default component.exports